import React from "react";
import { connect } from 'react-redux';
import ProtectedRoute from "./ProtectedRoutes";
import Authenticator from "../services/Authenticator";
import PageNotAllowed from "../container/PageNotAllowed";

/**
 *  A ProtectedRoute for the announcements publisher screens (Announcements -> Manage / Post).
 *
 *  Who may open them: HR, or a user the server flagged as a publisher (an active department
 *  head) — `user.is_broadcast_publisher` comes from the profile payload. Everyone else gets the
 *  403 screen and the container is never mounted. The server enforces the same rule on every
 *  publisher endpoint; this guard is the menu-level convenience.
 *
 *  `allowAdmin` widens the guard to Admin for the responses page (SPEC 8.1: Admin is a
 *  responses viewer without being a publisher). The server still answers 403 to anyone
 *  outside the viewer rule, HR included.
 */
export const isBroadcastPublisher = (user) =>
  (user && user.is_broadcast_publisher === true) || Authenticator.scanLevel("HR");

const PublisherRoute = ({ user, children, dispatch, allowAdmin, ...routeProps }) => {
  const allowed = isBroadcastPublisher(user) || (!!allowAdmin && Authenticator.scanLevel("Admin"));
  return (
    <ProtectedRoute {...routeProps}>
      {allowed ? children : <PageNotAllowed />}
    </ProtectedRoute>
  );
}

const mapStateToProps = (state) => {
  return {
      user : state.user
  }
}

export default connect(mapStateToProps)(PublisherRoute);
